import { ID, ReorderItem } from '@griply/types';

export type ReorderSectionIds = {
  newSectionId?: ID;
  oldSectionId?: ID;
};

// Habits appear under multiple date sections, so the old section must be inferred from the affected drop set, not the full tree.
export const getReorderSectionIds = (
  itemId: ID,
  affectedSections: readonly ReorderItem[],
): ReorderSectionIds => {
  const newSectionItem = affectedSections.find((section) =>
    section.children?.includes(itemId),
  );

  if (!newSectionItem) {
    return { newSectionId: undefined, oldSectionId: undefined };
  }

  const oldSectionItem =
    affectedSections.find(
      (section) =>
        section.id !== newSectionItem.id && !section.children?.includes(itemId),
    ) ?? newSectionItem;

  return {
    newSectionId: newSectionItem.id,
    oldSectionId: oldSectionItem.id,
  };
};
